import { FF_PUBLISH_SMOKE_TEST } from '@wetransfer/transfer/constant/experiments';
import { getVariant } from '@wetransfer/transfer/modules/experiments';

import {
  advancedReceivingVariant,
  micrositesVariant,
  monetizationVariant,
} from './constants';
import type { SneakPeekVariant } from './types';

export const getSnowplowEventLabel = (variantName: string): string => {
  switch (variantName) {
    case micrositesVariant.name:
      return 'quick_pages';
    case monetizationVariant.name:
      return 'monetization';
    case advancedReceivingVariant.name:
      return 'adv_receiving';
    default:
      throw new Error('invalid variant name');
  }
};

export const getPublishSmokeTestFlagVariant = (): SneakPeekVariant => {
  const variantName = getVariant(FF_PUBLISH_SMOKE_TEST) as
    | 'quick-pages'
    | 'advanced-receiving'
    | 'pay-to-download'
    | 'control';

  switch (variantName) {
    case micrositesVariant.name:
      return micrositesVariant;

    case monetizationVariant.name:
      return monetizationVariant;

    case advancedReceivingVariant.name:
      return advancedReceivingVariant;

    case 'control':
    default:
      return undefined;
  }
};
